class Constant {
    static SYS_VERSION = 1

    static POINT_COLOR = '#ff0000'

    static POINT_WIDTH = 1.3 //单位mm
    static POINT_SELECT_DISTANCE = 0.5
    static DRAG_MIN_LEN = 1
    static RECT_DEF_HEIGHT = 5
    static RECT_DEF_WIDTH = 20

    static DIRECTION_PORTRAIT = "0"
    static DIRECTION_LANDSCAPE = "1"


    static DATA_LOCAL = "print-set"

    static PAPER_TYPE_FIT = "fit"


    //list列样式
    static LIST_COL_DISPLAY_TEXT = "text"
    static LIST_COL_DISPLAY_IMAGE = "image"
    static LIST_COL_DISPLAY_BARCODE = "barcode"
    static LIST_COL_DISPLAY_QRCODE = "qrcode"

    //垂直对齐
    static VERTICAL_TOP = "top";
    static VERTICAL_MIDDLE = "middle";
    static VERTICAL_BOTTOM = "bottom";
    
    //水平对齐
    static ALIGN_LEFT = "left"
    static ALIGN_CENTER = "center"
    static ALIGN_RIGHT = "right"

    //线条元素类型
    static LINE_TYPE_LINE = "0"
    static LINE_TYPE_ELLI = "1"
    static LINE_TYPE_RECT = "2"


}


export {
    Constant
}